<button
  [attr.id]="props.id ? props.id + '-btn-close' : 'modal-btn-close'"
  type="button"
  class="close-button"
  (click)="handleClose()"
  >
  <app-icon name="close" size="24" alt="Close" color="#333E48" />
</button>

<div [attr.id]="props.id ? props.id + '-title' : null" class="title-container">
  {{ props.title }}
</div>

<div [attr.id]="props.id ? props.id + '-content' : null" class="content-container">
  @if (props.message) {
    <p style="padding: 8px 0" [attr.id]="props.id ? props.id + '-message' : null">
      {{ props.message }}
    </p>
  }
  <ng-container *ngTemplateOutlet="props.contentTemplate"></ng-container>
  <ng-content></ng-content>
</div>

@if (!props?.cancelButton?.hide || props?.confirmButton) {
  <div class="buttons-container">
    @if (!props?.cancelButton?.hide) {
      <app-button
        [id]="props?.cancelButton?.id || (props.id ? props.id + '-btn-cancel' : 'modal-btn-cancel')"
        [buttonStyle]="getCancelButtonStyle()"
        (click)="handleCancel()"
        >
        {{ cancelButtonText }}
      </app-button>
    }
    @if (props?.confirmButton) {
      <app-button
        [id]="props?.confirmButton?.id || (props.id ? props.id + '-btn-confirm' : 'modal-btn-confirm')"
        [buttonStyle]="getConfirmButtonStyle()"
        [icon]="props.confirmButton.icon"
        [disabled]="props.confirmButton?.disabled"
        (click)="handleConfirm()"
        >
        {{ confirmButtonText }}
      </app-button>
    }
  </div>
}
